import { render, staticRenderFns } from "./CategorySelectBox.vue?vue&type=template&id=ae3d8e3a&scoped=true"
import script from "./CategorySelectBox.vue?vue&type=script&lang=js"
export * from "./CategorySelectBox.vue?vue&type=script&lang=js"
import style0 from "./CategorySelectBox.vue?vue&type=style&index=0&id=ae3d8e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3d8e3a",
  null
  
)

export default component.exports